import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	orgSelectorDropdownNoOrgForOrgAdmin: {
		id: 'fastshift.dashboard.welcome-banner.org-selector.selected-org-is-no-org',
		defaultMessage: 'No cloud organization',
		description:
			'Message for MOVE tickets that do not contain a reference to a destination cloud org, in the org selector dropdown button on welcome banner',
	},
	orgSelectorDropdownOtherOrgsForOrgAdmin: {
		id: 'fastshift.dashboard.welcome-banner.org-selector.selected-org-is-other-orgs',
		defaultMessage: 'Other cloud organizations',
		description:
			'Message for MOVE tickets associated with cloud orgs that the customer is NOT org admin of, in the org selector dropdown button on welcome banner',
	},
	orgSelectorDropdownNoOrgSelected: {
		id: 'fastshift.dashboard.welcome-banner.org-selector.org-not-selected-fallback',
		defaultMessage: 'Select an organization...',
		description:
			'Fallback message displayed instead of the dropdown when the org has not been selected. Since orgs are selected automatically, this is only shown if there is a bug.',
	},
	orgSelectorDropdownAriaLabel: {
		id: 'fastshift.dashboard.welcome-banner.org-selector.aria-label',
		defaultMessage: 'Select organization',
		description: 'Aria label for the org selector dropdown button',
	},
});
